import React from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { useAuth } from "../../context/AuthContext"
import "./admin.css"

const navLinks = [
  { to: "/admin/dashboard",    icon: "fa-th-large",       label: "Dashboard"      },
  { to: "/admin/courses",      icon: "fa-graduation-cap", label: "Courses"        },
  { to: "/admin/live-sessions",icon: "fa-video",          label: "Live Sessions"  },
  { to: "/admin/students",     icon: "fa-users",          label: "Students"       },
  { to: "/admin/payments",     icon: "fa-credit-card",    label: "Payments"       },
  { to: "/admin/enrollments",  icon: "fa-list-alt",       label: "Enrolments"     },
  { to: "/admin/contacts",     icon: "fa-envelope",       label: "Contacts"       },
]

const AdminLayout = ({ children, title }) => {
  const { admin, adminLogout } = useAuth()
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const handleLogout = () => {
    adminLogout()
    navigate("/admin/login")
  }

  const initials = admin?.name?.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2) || "A"

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className="admin-sidebar">
        <div className="admin-sidebar-logo">
          <img src="/images/logo.png" alt="Rovers Access" />
          <div>
            <span>Rovers Access</span>
            <small>Admin Panel</small>
          </div>
        </div>

        <nav className="admin-nav">
          {navLinks.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={pathname === link.to ? "active" : ""}
            >
              <i className={`fa ${link.icon}`}></i>
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <div className="admin-sidebar-user">
            <i className="fa fa-shield-alt"></i>
            {admin?.name} · {admin?.role}
          </div>
          <button className="admin-logout-btn" onClick={handleLogout}>
            <i className="fa fa-sign-out-alt"></i> Logout
          </button>
        </div>
      </aside>

      {/* Main */}
      <div className="admin-main">
        <div className="admin-topbar">
          <h1>{title || "Admin Panel"}</h1>
          <div className="admin-topbar-right">
            <span>{admin?.email}</span>
            <div className="admin-avatar">{initials}</div>
          </div>
        </div>
        <div className="admin-content">
          {children}
        </div>
      </div>
    </div>
  )
}

export default AdminLayout
